import { type CommonModalProps } from 'renderer/components/CommonModal/context';
import urls from 'constants/urls';
import { navigateTo } from 'renderer/utils/navigate';

import { ModalCloseOptions } from './modalCloseOptions';

export const modalSeverityValues = {
  INFO: 'info', // general information modal
  ERROR: 'error', // a modal shown due to an error
  CONFLICT: 'conflict', // usually a BE triggered error e.g. trolley conflict
} as const;

export const createNetworkErrorModal = (navigate?: (url: string) => void): CommonModalProps => {
  const navigateFn = navigate ?? navigateTo;

  return {
    id: 'networkErrorModal',
    severity: modalSeverityValues.ERROR,
    buttons: [
      {
        buttonText: 'Go to Homepage',
        buttonValue: ModalCloseOptions.OK,
        onClick: () => navigateFn(urls.homepage),
      },
    ],
    messageText: [
      'These problems are normally temporary. Please refresh the page, restart your browser or try again a little later.',
    ],
    titleText: "Sorry, we're experiencing an unexpected error.",
    cannotClose: true,
  };
};

export const networkErrorModal: CommonModalProps = createNetworkErrorModal();

export const createUnexpectedErrorModal = (): CommonModalProps => {
  return {
    ...networkErrorModal,
    id: 'unexpectedErrorModal',
    buttons: [
      {
        buttonText: 'OK',
        buttonValue: ModalCloseOptions.OK,
        onClick: () => {
          window.location.reload();
        },
      },
    ],
  };
};

export const unexpectedErrorModal: CommonModalProps = createUnexpectedErrorModal();

export type TrolleyConflictModalOptions = {
  titleText?: string;
  dismissalText?: string;
};

export const createTrolleyConflictModal = (
  message: string,
  { titleText, dismissalText }: TrolleyConflictModalOptions = {},
): CommonModalProps => ({
  id: 'trolleyConflictModal',
  severity: modalSeverityValues.CONFLICT,
  titleText: titleText ?? "Sorry, we couldn't update your trolley",
  messageText: [message],
  buttons: [
    {
      buttonText: dismissalText ?? 'OK',
      buttonValue: ModalCloseOptions.OK,
    },
  ],
});

export const getAllFavouritesNetworkErrorModal: CommonModalProps = {
  id: 'getAllFavouritesNetworkErrorModal',
  severity: modalSeverityValues.ERROR,
  titleText: 'Unable to load your Favourites',
  messageText: ['Please refresh the page, check your internet connection or try again later.'],
  buttons: [{ buttonText: 'OK', buttonValue: ModalCloseOptions.OK }],
};

export const updateFavouriteNetworkErrorModal = {
  id: 'updateFavouriteNetworkErrorModal',
  severity: modalSeverityValues.ERROR,
  titleText: 'Unable to update your Favourites',
  messageText: ['Please refresh the page, check your internet connection or try again later.'],
  buttons: [{ buttonText: 'OK', buttonValue: ModalCloseOptions.OK }],
};

export const getTrolleyNetworkErrorModal: CommonModalProps = {
  id: 'trolleyNetworkErrorModal',
  severity: modalSeverityValues.ERROR,
  titleText: "Sorry, we're experiencing an unexpected error.",
  messageText: [
    'These problems are normally temporary. Please refresh the page, restart your browser or try again a little later.',
  ],
  buttons: [{ buttonText: 'OK', buttonValue: ModalCloseOptions.OK }],
};
